<mat-toolbar color="accent">
  @if (data.section === 'tasks') {
    Active Tasks
  } @else {
    Active Lab Jobs
  }
</mat-toolbar>

<mat-dialog-content>
  @if (data.section === 'tasks') {
    <pr-patient-tasks [patient]="data.patient" />
  } @else {
    <pr-patient-lab-jobs [patient]="data.patient" />
  }
</mat-dialog-content>

<mat-dialog-actions>
  <pt-buttons-container padding="none">
    <button mat-stroked-button mat-dialog-close>Close</button>
  </pt-buttons-container>
</mat-dialog-actions>
